import * as WebViewActions from '@medscape-promo/medscapetv/web-view/web-view.actions';
import * as CommentsDrawerActionTypes from './action-types.constants';
import * as CommentsDrawerActions from './comments-drawer.actions';
import * as RouterActionTypes from '../../main-router/action-types.constants';
import fetchContent from '../utils/fetch-content';
import loadScripts from '../utils/load-scripts';
import loadStyles from '../utils/load-styles';
import { COMMENTS_TRACKING } from '@medscape-promo/medscapetv/omniture-tracking';
const { mmodule, mlink } = COMMENTS_TRACKING;





// PlayerMiddleware is added to the media-player.store
const CommentsDrawerMiddleware = (storeAPI) => {
    let contentPath = "";
    return next => action => {
        // Do something in here, when each action is dispatched
        //const state = storeAPI.getState();
        //console.log('[PlayerMiddleware] current state', state)
        //console.log('[CommentsDrawerMiddleware] dispatching', action)
        let result = next(action);
        const nextState = storeAPI.getState();
        //console.log('[PlayerMiddleware] next state', nextState);

        switch (action.type) {
            case RouterActionTypes.READY:
            case RouterActionTypes.HISTORY_LOCATION_CHANGE:
                (() => {
                    const location = typeof action.location !== 'undefined' ? action.location : action.BrowserRouter.history.location;
                    const pathnames = location.pathname.split("/");
                    const seriesPath = nextState.Main["series-path"];
                    contentPath = `${seriesPath}/comments/${pathnames.pop()}`;

                    //console.log('[CommentsDrawerMiddleware] dispatching', action, "\ncontentPath:", contentPath);
                    if (nextState.CommentsDrawer.open === true) {
                        fetchContent(storeAPI, CommentsDrawerActions, contentPath);
                    }
                })();
                break;
            case CommentsDrawerActionTypes.OPEN:
                (() => {
                    //console.log('[CommentsDrawerMiddleware] dispatching', action);
                    if (nextState.CommentsDrawer.content.trim() === "") {
                        fetchContent(storeAPI, CommentsDrawerActions, contentPath);
                    }

                    storeAPI.dispatch(WebViewActions.omnitureTracking(`${mmodule}_${mlink.open}`));
                })()
                break;
            case CommentsDrawerActionTypes.CLOSE:
                storeAPI.dispatch(WebViewActions.omnitureTracking(`${mmodule}_${mlink.close}`));
                break;
            case CommentsDrawerActionTypes.RENDERED_CONTENT:
                (() => {
                    //console.log('[CommentsDrawerMiddleware] dispatching', action);
                    if (action.container != null) {
                        loadScripts(action.container);
                        loadStyles(action.container)
                    }
                })()


        }
        return result
    }



}

export default CommentsDrawerMiddleware;